import React, { useState, useEffect } from 'react'
import {
  Container,
  Box,
  Paper,
  Typography,
  TextField,
  MenuItem,
  useTheme
} from '@mui/material'
import ConnectWithPublicDomain from './white-label-team-management/publicDomain'
import ConnectWithPrivateDomain from './white-label-team-management/privateDomain'
import { useAddSmtpEmailMutation, useGetSmtpEmailMutation } from 'src/services/smtp-service'
import toast from 'react-hot-toast'
import { EmailSendAccBtn } from './white-label-team-management/emailSendAccBtn'

const CustomSMTPConfiguration = () => {
  const theme = useTheme()
  const [addSmtpEmail] = useAddSmtpEmailMutation()
  const [getSmtpEmail, { data }] = useGetSmtpEmailMutation()

  const [accounts, setAccounts] = useState()
  const [currentAccount, setCurrentAccount] = useState([])
  const [emailDomain, setEmailDomain] = useState('no_email_domain_selected_yet')
  const [selectEmail, setSelectEmail] = useState('no_email_selected_yet')
  const [saveCancelBtnHideShow, setSaveCancelBtnHideShow] = useState(false)

  useEffect(() => {
    if (data && data.data) {
      setAccounts(data?.data?.accounts)
      setCurrentAccount(data?.data?.smtpAccount?.accountId)
      data?.data?.smtpAccount?.accountId ? setSelectEmail(data?.data?.smtpAccount?.accountId) : setSelectEmail('no_email_selected_yet')
    }
  }, [data])

  useEffect(() => {
    getSmtpEmail()
  }, [])

  const handleEmailDomainChange = (value) => {
    setEmailDomain(value)
  }

  const handleEmailChange = async (_id) => {
    try {
      const account = accounts.find(account => account._id === _id)

      const payload = {
        email: account?.email,
        accountId: account?._id
      }

      const { message, success } = await addSmtpEmail(payload).unwrap()
      if (success) {
        setSaveCancelBtnHideShow(false)
        getSmtpEmail()
      }
      toast.success(`${message || 'Smtp email setup updated successfully!'}`)
    } catch ({ data: error }) {
      toast.error(`${error.status || 'Error'}: ${error.message || 'Falied to update smtp email !'}`)
    }
  }

  const handleOnDropDownChange = (value) => {
    setSelectEmail(value)
    setSaveCancelBtnHideShow(true)
  }

  const handleOnCancel = () => {
    currentAccount ? setSelectEmail(currentAccount) : setSelectEmail('no_email_selected_yet')
    setSaveCancelBtnHideShow(false)
  }

  return (
    <Container sx={{ maxWidth: { xs: 800, xl: '100%' }, margin: 'auto', padding: '0px !important' }}>
      <Box sx={{ mb: 2 }}>
        <Paper sx={{ p: 3 }}>
          <Box sx={{ mb: 2 }}>
            <Typography variant='subtitle2' sx={{ color: theme.palette.primary.main }}>
              Select Email Type
            </Typography>
            <TextField
              select
              fullWidth
              value={emailDomain}
              onChange={(e) => handleEmailDomainChange(e.target.value)}
              sx={{ mt: 1 }}
            >
              <MenuItem value='no_email_domain_selected_yet' disabled>
                Select Email Type
              </MenuItem>
              <MenuItem value='Public'>Google/Hotmail/Outlook </MenuItem>
              <MenuItem value='Private'>Custom SMTP</MenuItem>
            </TextField>
          </Box>
          {emailDomain === 'Public' && <ConnectWithPublicDomain onCancel={() => handleEmailDomainChange('no_email_domain_selected_yet')} />}
          {emailDomain === 'Private' && <ConnectWithPrivateDomain onCancel={() => handleEmailDomainChange('no_email_domain_selected_yet')} />}

          {accounts?.length > 0 && (
            <>
              <Box sx={{ mb: 2 }}>
                <Typography variant='subtitle2' sx={{ color: theme.palette.primary.main }}>
                  Select Email Sending Account
                </Typography>
                <TextField
                  select
                  fullWidth
                  value={selectEmail}
                  onChange={(e) => handleOnDropDownChange(e.target.value)}
                  sx={{ mt: 1 }}
                >
                  <MenuItem value='no_email_selected_yet' disabled>
                    Select Email Sending Account
                  </MenuItem>
                  {accounts?.map((account) => (
                    <MenuItem key={account._id} value={account._id}>
                      {account.email}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
              {saveCancelBtnHideShow && <EmailSendAccBtn value={selectEmail} handleSubmit={(value) => handleEmailChange(value)} onCancel={() => handleOnCancel()} />}
            </>
          )}
        </Paper>
      </Box>
    </Container>
  )
}
export default CustomSMTPConfiguration
